module.exports = __webpack_public_path__ + "static/media/stupicasti_stalak.1cbe9f11.png";